<template>
  <div id="app">
    <site-header/>
    <hero/>

    <!-- Render content from router. -->
    <router-view></router-view>

    <affiliates/>
    <site-footer/>
  </div>
</template>

<script>
  global.jQuery = require('jquery');
  var $ = global.jQuery;
  window.$ = $;

  import './assets/css/main.scss'

  import siteHeader from './components/Header.vue'
  import hero from './components/Hero.vue'
  import affiliates from './components/Affiliates.vue'
  import siteFooter from './components/Footer.vue'

  export default {
    name: 'App',
    components:{
      siteHeader,
      hero,
      affiliates,
      siteFooter
    }
  }

  $(function() {


    if (window.location.href.indexOf("#") != -1) {
      locationsScroll();
    }

    $('.locations-link').on('click', function(e) {
      e.preventDefault();
      console.log(location.pathname)
      if(location.pathname === '/'){
        locationsScroll();
      }
      else{
        window.location.href = '/#locations';
      }
    })

    var loc;

    $(document).on("mouseenter", ".location", function() {
      loc = $(this).attr('data-location');
      $('#location-'+loc).addClass('active');
    });

    $(document).on("mouseleave", ".location", function() {
      $('#location-'+loc).removeClass('active');
      loc;
    });

    function locationsScroll(){
      $('html, body').animate({
        scrollTop: $("#dealership-locations").offset().top - 20
      }, 1000);
    }

    $('.navicon').on('click', function() {
      var clicks = $(this).data('clicks');
      if (clicks) {
        $('.tcon').removeClass('tcon-transform');
        $('.nav-mobile').removeClass('open');
      } else {
        $('.tcon').addClass('tcon-transform');
        $('.nav-mobile').addClass('open');
      }
      $(this).data("clicks", !clicks);
    });

    $('.locations-link-mobile').on('click', function() {
      $('.navicon').click();
    });

    $(window).resize(function() {
      if ($(window).width() > 1024 && $('.tcon').hasClass('tcon-transform')){
       $('.navicon').click();
      }
    });
  });
</script>



// WEBPACK FOOTER //
// src/App.vue